import React from 'react';

function MaterialCard({ material, onClick }) {
    const getSuitabilityBadge = (suitability) => {
        if (!suitability) return null;
        
        const className = suitability.toLowerCase();
        return <span className={`badge ${className}`}>{suitability}</span>;
    };

    return (
        <div className="material-card" onClick={onClick}>
            <h3>{material.name}</h3>
            {material.formula && (
                <div className="material-formula">{material.formula}</div>
            )}
            
            <div className="material-info">
                {material.type && (
                    <div className="info-row">
                        <span className="info-label">Тип:</span>
                        <span className="info-value">{material.type}</span>
                    </div>
                )}
                
                {material.density && (
                    <div className="info-row">
                        <span className="info-label">Густина:</span>
                        <span className="info-value">{material.density} kg/m³</span>
                    </div>
                )}
                
                {material.propertyValue && (
                    <div className="info-row">
                        <span className="info-label">{material.propertyName}:</span>
                        <span className="info-value">
                            {material.propertyValue.toLocaleString()} {material.propertyUnit}
                        </span>
                    </div>
                )}
                
                {material.suitability && (
                    <div className="info-row">
                        <span className="info-label">Придатність:</span>
                        <span className="info-value">
                            {getSuitabilityBadge(material.suitability)}
                        </span>
                    </div>
                )}
                
                {material.notes && (
                    <div className="info-row" style={{ 
                        flexDirection: 'column', 
                        alignItems: 'flex-start',
                        marginTop: '0.5rem'
                    }}>
                        <span className="info-label">Примітки:</span>
                        <span className="info-value" style={{ 
                            fontSize: '0.85rem', 
                            color: '#666',
                            marginTop: '0.3rem'
                        }}>
                            {material.notes}
                        </span>
                    </div>
                )}
            </div>
            
            <div style={{ 
                marginTop: '1rem', 
                paddingTop: '1rem', 
                borderTop: '1px solid #e0e0e0',
                fontSize: '0.85rem',
                color: '#667eea',
                textAlign: 'center'
            }}>
                Клікніть для детальної інформації →
            </div>
        </div>
    );
}

export default MaterialCard;
